import { Injectable } from '@angular/core';
import { STWebSocketService } from 'scaletech-core';
import { StarbaseLoginService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService extends STWebSocketService {

  constructor(private loginService: StarbaseLoginService) {
    super(loginService);
    if (this.loginService.isLoggedIn()) {
      this.initWebSocket();
    } else {
      this.loginService.loginState.subscribe((loggedIn) => {
        if (loggedIn) {
          this.initWebSocket();
        }
      });
    }
  }
}
